'use strict';

export const bFaq = {
    container: document.querySelectorAll('.bFaq'),
    items: document.querySelectorAll('.bFaq_item'),

    init() {
        if (!this.container.length) return;

        this.items.forEach((item) => {
            const title = item.querySelector('.bFaq_item-title');
            const content = item.querySelector('.bFaq_item-content');
            const plusIcon = item.querySelector('.bFaq_item-plus');

            if (!title || !content) return;

            // Initialiser la hauteur à 0 explicitement
            content.style.maxHeight = '0px';

            title.onclick = () => {
                this.toggleItem(item, content, plusIcon);
            };

            // Accessibilité clavier
            title.onkeydown = (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggleItem(item, content, plusIcon);
                }
            };

            // Rendre le titre focusable
            title.setAttribute('tabindex', '0');
            title.setAttribute('role', 'button');
            title.setAttribute('aria-expanded', 'false');
        });

        // Ouvrir le premier item automatiquement
        const firstItem = document.querySelector('.bFaq_item');

        if (firstItem) {
            const content = firstItem.querySelector('.bFaq_item-content');
            const plusIcon = firstItem.querySelector('.bFaq_item-plus');

            if (content) {
                const height = content.scrollHeight + 20;

                firstItem.classList.add('active');
                if (plusIcon) plusIcon.classList.add('active');

                content.style.maxHeight = height + 'px';

                const title = firstItem.querySelector('.bFaq_item-title');
                if (title) {
                    title.setAttribute('aria-expanded', 'true');
                }
            }
        }
    },

    toggleItem(item, content, plusIcon) {
        const isActive = item.classList.contains('active');
        const title = item.querySelector('.bFaq_item-title');

        if (isActive) {
            // Fermer l'item
            item.classList.remove('active');
            plusIcon.classList.remove('active');
            content.style.maxHeight = '0px';
            if (title) {
                title.setAttribute('aria-expanded', 'false');
            }
        } else {
            // Calcul de la hauteur avant d'ouvrir
            const contentHeight = content.scrollHeight + 20; // +20 pour le padding-bottom

            // Forcer un reflow pour que la transition fonctionne
            content.style.maxHeight = '0px';
            void content.offsetHeight; // Force le reflow

            // Ouvrir l'item avec animation
            item.classList.add('active');
            plusIcon.classList.add('active');
            content.style.setProperty('--content-height', contentHeight + 'px');
            content.style.maxHeight = contentHeight + 'px';

            if (title) {
                title.setAttribute('aria-expanded', 'true');
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/scripts/components/bFaq.js